import { type ECommerceResetEvent } from './eCommerceTrackingEventSchema';

export const buildECommerceResetEvent = (): ECommerceResetEvent => {
  const eCommerceResetEvent = {
    event_name: 'ecommerce_reset' as const,
    ecommerce: null
  };

  return eCommerceResetEvent;
};
